import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSettings } from 'app/modules/shared/app.settings';
import { InputNumberModule } from 'primeng/inputnumber';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';

@Component({
  selector: 'app-counter',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputNumberModule],
  templateUrl: './counter.component.html',
  styleUrl: './counter.component.scss'
})
export class CounterComponent implements OnInit {
  @Input() field: any;
  formName: FormGroup;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  placeholder: any = null;
  configSettingEntityCode = AppSettings.ENTITY_CODE.CONFIG_SETTING;
  securitySettingsEntityCode = AppSettings.ENTITY_TYPE.SECURITY_SETTINGS;

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    const editFormValue = this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].value;
    if(this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].value) {
      this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue(editFormValue);
    } else {
      if (this.field.validation.min || this.field.validation.min === 0) {
        this.formName.controls[this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode].setValue(this.field.validation.min);
      }
    }
    this.placeholder = this.cs.getLabelValue(`${this.moduleName  }.fields.${  this.field.attributeCode  }.placeholder`, this.attributeLabels, null);
  }

}
